import { h } from 'preact';
import dlv from 'dlv';
import style from './style';

import CategoryCluster from '../../../clusters/category-cluster/phone';
import RecommendedCluster from '../../../clusters/recommended-cluster/phone';
import PromoCluster from '../../../clusters/promo-cluster';
import SupportCluster from '../../../clusters/support-cluster';
import { TopBorder } from '../../../pieces/top-border';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../pieces/taboola-js';
import { getCommonProps } from '../../../../lib/page';

import { Column, ColumnNoPadding, Row, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';
import Notifications from '@cube/notifications';
import { DccWidget } from '@cube/dcc-widget-v2';

export const Phone = ({ pageConfig, ...props }) =>
	(
		<div class={style.phone}>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<ContainerFluid>
				<Row>
					<ColumnNoPadding>
						<Notifications
							{...getCommonProps(props)}
						/>
						<DccWidget
							{...dlv(pageConfig, 'clusters.dcc')}
							{...getCommonProps(props)}
						/>
					</ColumnNoPadding>
				</Row>
				<Row>
					<Column>
						<TaboolaJs {...dlv(pageConfig, 'taboola.subDcc')} qeId="sc-home-subdcc" />
					</Column>
				</Row>
				<Row>
					<ColumnNoPadding>
						<SupportCluster
							{...dlv(pageConfig, 'clusters.support')}
							layout="phone"
							qeId="sc-home-alerts"
							{...getCommonProps(props)}
						/>
					</ColumnNoPadding>
				</Row>
				<Row class={style.clusterRow}>
					<Column>
						{ dlv(pageConfig, 'clusters.promo') &&
							<PromoCluster
								{...dlv(pageConfig, 'clusters.promo')}
								{...getCommonProps(props)}
							/>
						}
						<TopBorder />
						<RecommendedCluster
							{...dlv(pageConfig, 'clusters.recommended')}
							qeId="sc-home-recommended"
							{...getCommonProps(props)}
						/>
						<div>
							<SadlibAd id="sc_home_phone_1" type="phoneSquare" />
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestEntertainment')}
								qeId="sc-home-entertainment"
								{...getCommonProps(props)}
							/>
							<SadlibAd id="sc_home_phone_2" type="phoneSquare" />
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestHealth')}
								qeId="sc-home-latestHealth"
								{...getCommonProps(props)}
							/>
							<SadlibAd id="sc_home_phone_3" type="phoneSquare" />
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestNews')}
								qeId="sc-home-news"
								{...getCommonProps(props)}
							/>
							<SadlibAd id="sc_home_phone_4" type="phoneSquare" />
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestSports')}
								qeId="sc-home-sports"
								{...getCommonProps(props)}
							/>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestBusiness')}
								qeId="sc-home-business"
								{...getCommonProps(props)}
							/>
							<TaboolaJs {...dlv(pageConfig, 'taboola.bottomPage')} qeId="sc-home-taboolabottompage" />
						</div>
					</Column>
				</Row>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
